/**
 * Dimensional algebra over the five base dimensions of plan §5.2 — `JOD km L day year`.
 *
 * A dimension is a sparse map of base → exponent: `JOD/day` is `{ JOD: 1, day: -1 }` and a fraction is
 * `{}`. Multiplication adds exponents, division subtracts them, and addition demands equality — which
 * is the whole reason `inspected + odometer` can be refused before anybody publishes it.
 */
export const BASE_DIMENSIONS = ['JOD', 'km', 'L', 'day', 'year'];
/** Fractions, counts, flags and the result of dividing like by like. */
export const DIMENSIONLESS = {};
export const dimensionOf = (entries) => normalize(entries);
const normalize = (dimension) => {
    const result = {};
    for (const base of BASE_DIMENSIONS) {
        const exponent = dimension[base];
        if (exponent !== undefined && exponent !== 0) {
            result[base] = exponent;
        }
    }
    return result;
};
export const isDimensionless = (dimension) => Object.keys(normalize(dimension)).length === 0;
export const dimensionsEqual = (a, b) => {
    const left = normalize(a);
    const right = normalize(b);
    return BASE_DIMENSIONS.every((base) => (left[base] ?? 0) === (right[base] ?? 0));
};
export const multiplyDimensions = (a, b) => normalize(Object.fromEntries(BASE_DIMENSIONS.map((base) => [base, (a[base] ?? 0) + (b[base] ?? 0)])));
export const divideDimensions = (a, b) => normalize(Object.fromEntries(BASE_DIMENSIONS.map((base) => [base, (a[base] ?? 0) - (b[base] ?? 0)])));
export const powerDimension = (dimension, exponent) => normalize(Object.fromEntries(BASE_DIMENSIONS.map((base) => [base, (dimension[base] ?? 0) * exponent])));
/** `JOD·km⁻¹` style text for an error message; a dimensionless quantity prints as `fraction`. */
export const formatDimension = (dimension) => {
    const normalized = normalize(dimension);
    const bases = BASE_DIMENSIONS.filter((base) => normalized[base] !== undefined);
    if (bases.length === 0) {
        return 'fraction';
    }
    return bases
        .map((base) => {
        const exponent = normalized[base];
        return exponent === 1 ? base : `${base}^${exponent}`;
    })
        .join('·');
};
//# sourceMappingURL=dimension.js.map